var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"d-flex"},[(this.$store.state.LoginStore.token)?_c('div',[_c('oryl-navbar',{key:_vm.key}),_c('oryl-cart')],1):_vm._e(),_c('v-main',{staticClass:"orylbackground"},[_c('router-view',{key:_vm.key})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }